import { useEffect, useRef } from 'react'
import { FormInstance } from 'antd/lib/form'
import { useSelector } from 'react-redux'

import { userProfileActions, UserProfileState } from '../../../../../store/slices/userProfileSlice'
import { RootState, useAppDispatch } from '../../../../../store/store'
import { Modal } from '../../../../common'

type UseChangePasswordUserProfile = (
  form: FormInstance<any>,
  callback: () => void,
  options?: {
    showSuccess?: boolean
    onSuccess?: () => void
  },
) => {
  loading: boolean
  methods: {
    onSave: () => void
    onCancel: () => void
  }
}

const useChangePasswordManagerUserProfile: UseChangePasswordUserProfile = (form, callback, options = {}) => {
  const eventInitiator = useRef<boolean>(false)
  const dispatch = useAppDispatch()
  const { showSuccess = true, onSuccess } = options

  const { needToUpdate, loadingForm: loading } = useSelector<RootState, UserProfileState>((state) => state.userProfile)

  useEffect(() => {
    if (needToUpdate && eventInitiator.current) {
      eventInitiator.current = false
      if (showSuccess) {
        Modal.success({
          title: 'Данные успешно изменены',
          okText: 'Понятно',
          className: 'confirmModalLayout confirmModalSuccessLayout',
        })
      }
      form.resetFields()
      callback()
      if (onSuccess) onSuccess()
    }
  }, [needToUpdate, callback, form, onSuccess, showSuccess])

  const onSave = () => {
    form.validateFields().then(() => {
      const fields = form.getFieldsValue()
      delete fields.confirm
      dispatch(userProfileActions.setPasswordUserProfile(fields))
      eventInitiator.current = true
    })
  }

  const onCancel = () => {
    form.resetFields()
    callback()
  }

  return {
    loading,
    methods: {
      onSave,
      onCancel,
    },
  }
}

export default useChangePasswordManagerUserProfile
